module.exports = "/v2/pages/dashboard/dist/962a1bf31c081691065fe333d9fa8105.svg";